import lecardHelper from './lecard-helper'

function toMinutes(horario) {
  const [hora, minuto] = horario.split(':').map(Number);
  return hora * 60 + minuto;
}

export function isDisponivelNoHorario(item, now) {
  const turnos = item.turnos || [];

  if (!now || !turnos.length) {
    return true;
  }

  const nowMin = toMinutes(now);

  return turnos.some(turno => {
    const inicio = toMinutes((turno.horario_inicio || '').slice(0, 5));
    const fim = toMinutes((turno.horario_fim || '').slice(0, 5));
    return nowMin >= inicio && nowMin <= fim;
  });
}

export function normalizeCardapioProdutos(categorias = []) {
  const produtos = [];
  const promocoes = [];

  const categoriasNormalizadas = categorias.map(categoria => ({
    ...categoria,
    produtos: (categoria.produtos || []).map(produto => {
      const sabores = Array.isArray(produto.sabores)
        ? produto.sabores
        : (produto.sabores ? produto.sabores.split(',') : []);
      const possui_promocao = produto.possui_promocao === true;
      const produtoNormalizado = {
        ...produto,
        sabores,
        nome_categoria: categoria.nome_categoria,
        texto_busca: lecardHelper.normalizeString([
          produto.nome_produto,
          categoria.nome_categoria,
          produto.descricao_produto,
          sabores.join(' ')
        ].filter(Boolean).join(' ')),
        possui_promocao
      };

      produtos.push(produtoNormalizado);

      if (possui_promocao) {
        promocoes.push(produtoNormalizado);
      }

      return produtoNormalizado;
    })
  }));

  return { categorias: categoriasNormalizadas, produtos, promocoes };
}
